const bannerNavs = document.querySelectorAll(".menu-banner");
bannerNavs.forEach(section => {
    let items = section.querySelectorAll(".image-nav li button");
    let imageArea = section.querySelector(".grid__media");
    items.forEach(item => {
        item.addEventListener("click", (e) => {
            let src= item.dataset.imgSrc;
            console.log(src)
            e.preventDefault();
            items.forEach(el => {
                el.classList.remove("selected");
            })
            item.classList.add("selected");
            imageArea.style.backgroundImage = "url('" + src + "')";
        })
    });
});